import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {SVGIcon} from '@homeaway/react-svg';
import {ALARM__24} from '@homeaway/svg-defs/lib/defs/ALARM__24';
import {CHECK__16} from '@homeaway/svg-defs/lib/defs/CHECK__16';
import {Button} from '@homeaway/react-buttons';
import translate from '../../../../../../utils/translations';
import RequestActions from './RequestActions/RequestActions';
import ManageBookingSection from '../../ManageBookingSection/ManageBookingSection';
import Spinner from '../../../../../atoms/Spinner/Spinner';
import RefundInfoContext from '../../../../../context/RefundInfoContext';
import {ACTION_LOCATION} from '../../../../../molecules/VaFloating/constants';

const CancellationRequest = (props) => {
    const {
        isLoading,
        showRefundInfo,
        updateActionLocation,
        updateChatWidgetCounter,
        updateIsLoading,
        updateRefundInfoFlag,
    } = useContext(RefundInfoContext);

    const {
        backUrl,
        conversationId,
        existingRequestTitle,
        existingRequestBody,
        isCancellationRequested,
        isCancellationRequestedOverDay,
        requestActions,
        showRefundInfoBtn,
        translations,
    } = props;

    const openRefundVa = () => {
        updateIsLoading(true);
        updateActionLocation(ACTION_LOCATION.BOOKING_MODIFICATION_SECTION);

        if (!showRefundInfo) {
            updateRefundInfoFlag();
        } else {
            updateChatWidgetCounter();
        }
    };

    return (
        <ManageBookingSection data-testid="manage-booking-cancellation-request">
            <div className="CancelSection__section-content-container CancelSection__section-content-container__details">
                <div className="CancelSection__section-content CancelSection__section-content__header">
                    {isCancellationRequested && (
                        <span
                            className="cancellation-request-icon"
                            data-testid="alarm-icon"
                        >
                            <SVGIcon markup={ALARM__24} />
                        </span>
                    )}
                    {!isCancellationRequested && (
                        <span
                            className="cancellation-request-icon circle-bullet circle-bullet--cancellation"
                            data-testid="check-icon"
                        >
                            <SVGIcon markup={CHECK__16} />
                        </span>
                    )}
                    <span data-testid="request-title">
                        <strong>{existingRequestTitle}</strong>
                    </span>
                </div>
                <div className="CancelSection__section-content CancelSection__section-content__body">
                    <RequestActions actions={requestActions} />
                    <p data-testid="request-body">{existingRequestBody}</p>
                </div>
                {isCancellationRequestedOverDay && (
                    <div className="CancelSection__section-content">
                        <Link
                            to={{
                                pathname: `/traveler/th/inbox/conversation/${conversationId}/messages`,
                                state: {
                                    backUrl,
                                    tabChange: true,
                                },
                            }}
                        >
                            <Button
                                className={'property-contact-button'}
                                label={`${translate(
                                    translations,
                                    'trav-dash/trav-home',
                                    'messages',
                                    'th.details.propertyContact.sendMessage'
                                )} `}
                            />
                        </Link>
                    </div>
                )}
                {showRefundInfoBtn && (
                    <div className="CancelSection__section-content  margin-top-3x">
                        <Button
                            disabled={isLoading}
                            label={translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.details.refundInfo.button'
                            )}
                            onClick={openRefundVa}
                        />
                        <Spinner isLoading={isLoading} />
                    </div>
                )}
            </div>
        </ManageBookingSection>
    );
};

export default CancellationRequest;
